import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=b4bfe0c8"
import script from "./Tournaments.vue?vue&type=script&lang=js"
export * from "./Tournaments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports